import { render, staticRenderFns } from "./DocumentsInfo.vue?vue&type=template&id=d71536f2&scoped=true"
import script from "./DocumentsInfo.vue?vue&type=script&lang=js"
export * from "./DocumentsInfo.vue?vue&type=script&lang=js"
import style0 from "./DocumentsInfo.vue?vue&type=style&index=0&id=d71536f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71536f2",
  null
  
)

export default component.exports